export { default } from './Tickets.data';
